import type { WebsiteFrameDevice } from '@dukanti/shared';

/** The id of a crop tab; its panel is `framingPanelId(idPrefix)`. */
export const framingTabId = (idPrefix: string, device: WebsiteFrameDevice): string =>
  `${idPrefix}-tab-${device}`;

/** The id of the crop's tab panel. */
export const framingPanelId = (idPrefix: string): string => `${idPrefix}-panel`;
